import { gql } from "@apollo/client";

export const CAMPAIGN_STATES = gql`
  query CampaignStates(
    $where: CampaignStateWhereInput
    $like: CampaignStateWhereInput
    $take: Int
    $skip: Int
  ) {
    campaignStates(where: $where, take: $take, skip: $skip, like: $like) {
      data {
        id
        state
        type
      }
      count
    }
  }
`;

export const CAMPAIGN_STATE = gql`
  query CampaignState($where: CampaignStateWhereInput) {
    campaignState(where: $where) {
      id
      name
      description
    }
  }
`;

const campaignStates = { CAMPAIGN_STATES, CAMPAIGN_STATE };

export default campaignStates;
